export default __webpack_public_path__ + "static/media/warning--domestic-animals--g6.d8382f60.png";